var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogotypeVkM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logotype_vk_m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7347 4.91832C18.8705 4.49416 18.7347 4.18582 18.133 4.18582H16.133C15.628 4.18582 15.3955 4.45582 15.2597 4.74499C15.2597 4.74499 14.2305 7.21166 12.793 8.81166C12.3272 9.27499 12.1138 9.42916 11.8613 9.42916C11.7255 9.42916 11.5505 9.27499 11.5505 8.85082V4.89916C11.5505 4.39832 11.3955 4.16666 10.968 4.16666H7.82301C7.51217 4.16666 7.31801 4.39832 7.31801 4.62916C7.31801 5.11082 8.03634 5.22666 8.11384 6.57582V9.50666C8.11384 10.1425 7.99717 10.2583 7.74551 10.2583C7.06551 10.2583 5.41551 7.77166 4.42467 4.93749C4.23051 4.37916 4.03634 4.16666 3.53301 4.16666H1.51217C0.930508 4.16666 0.833008 4.43666 0.833008 4.72499C0.833008 5.24582 1.51217 7.86749 3.99801 11.3375C5.64801 13.7083 7.99801 14.9808 10.1147 14.9808C11.3955 14.9808 11.5505 14.6917 11.5505 14.21V12.4167C11.5505 11.8383 11.6672 11.7417 12.0755 11.7417C12.3663 11.7417 12.8905 11.8967 14.0755 13.0333C15.433 14.3833 15.6663 15 16.4247 15H18.4247C19.0063 15 19.2788 14.7108 19.123 14.1517C18.948 13.5933 18.288 12.7833 17.4338 11.8192C16.968 11.28 16.2688 10.6825 16.0555 10.3933C15.7638 10.0075 15.8422 9.85332 16.0555 9.50666C16.0363 9.50666 18.4822 6.07499 18.7347 4.91832Z",
    fill: "#70707A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeVkM);
export default __webpack_public_path__ + "static/media/logotype_vk_m.d5f7c868cd760e1f5e2c14dbab549692.svg";
export { ForwardRef as ReactComponent };